import {handleValidationChange} from '../CommonValidation';

export const validateDiscount = (data, days, branches, items, categories, setIsError) => {
    var isValid = true;

    if(items.length === 0 && categories.length === 0) {
        handleValidationChange("discount_items", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("discount_items", false, setIsError);
    }

    if(data.valid_from === "" || data.valid_from === undefined) {
        handleValidationChange("valid_from", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("valid_from", false, setIsError);
    }

    if(data.valid_to === "" || data.valid_to === undefined) {
        handleValidationChange("valid_to", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("valid_to", false, setIsError);
    }

    if(days.length === 0) {
        handleValidationChange("days", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("days", false, setIsError);
    }

    if(branches.length === 0) {
        handleValidationChange("branches", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("branches", false, setIsError);
    }

    return isValid
  
}